import React from 'react';
import { Leadtext } from '@ktag/styleguide/dist/react';

interface Props {
  leadtext: string;
}
const WAPLeadtext = ({ leadtext }: Props) => {
  const leadtextIsHtml = leadtext?.includes('<');

  if (leadtextIsHtml) {
    return (
      <Leadtext>
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: leadtext }}
        />
      </Leadtext>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Leadtext>{leadtext}</Leadtext>;
};

export default WAPLeadtext;
